import { create } from 'zustand'
import { BroadcastDevice } from '@magnetar/admin-api-interfaces'

interface BroadcastDeviceDialogState {
  isOpen: boolean
  currentBroadcastDevice: BroadcastDevice | null
  openDialog: (broadcastDevice: BroadcastDevice) => void
  closeDialog: () => void
  resetDialog: () => void
}

export const useBroadcastDeviceDialog = create<BroadcastDeviceDialogState>()((set) => ({
  isOpen: false,
  currentBroadcastDevice: null,
  openDialog: (broadcastDevice: BroadcastDevice) =>
    set({ isOpen: true, currentBroadcastDevice: broadcastDevice }),
  closeDialog: () => set({ isOpen: false }),
  resetDialog: () => set({ isOpen: false, currentBroadcastDevice: null }),
}))
